import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  API_RATE_LIMIT_HIT,
  TOKENS_BY_NSL_TOKEN_REQUEST,
  TOKENS_BY_NSL_TOKEN_SUCCESS,
  TOKENS_BY_NSL_TOKEN_FAILURE

} from '../actions/authConstants';

/* eslint-disable camelcase */

const initialState = {
  isLoading: null,
  user: null,
  loginError: {error: false, result: 'pending'},
};

export default function auth(state = initialState, action = {}) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
        loginError: {error: false, result: 'pending'}
      });
    case LOGIN_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        user: action.user,
        loginError: {error: false, result: ''},
      });
    case API_RATE_LIMIT_HIT:
      return Object.assign({}, state, {
        isLoading: false,
        loginError: {error: true, result: action.error},
      });
    case LOGIN_FAILURE:
      return Object.assign({}, state, {
        isLoading: false,
        loginError: {error: true, result: action.error},
      });
    case TOKENS_BY_NSL_TOKEN_REQUEST:
      return Object.assign({}, state, {
        nslLoading: true,
        error: false
      });
    case TOKENS_BY_NSL_TOKEN_SUCCESS:
      return Object.assign({}, state, {
        nslLoading: false,
        error: false
      });
    case TOKENS_BY_NSL_TOKEN_FAILURE:
      return Object.assign({}, state, {
        nslLoading: false,
        error: true
      });
    default:
      return state;
  }
}
/* eslint-enable camelcase */



// WEBPACK FOOTER //
// ./src/reducers/auth.js